import * as tslib_1 from "tslib";
import * as React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
var BusyIndicator = /** @class */ (function (_super) {
    tslib_1.__extends(BusyIndicator, _super);
    function BusyIndicator(props) {
        return _super.call(this, props) || this;
    }
    BusyIndicator.prototype.render = function () {
        return this.props.active ? this.renderBusyIndicator() : this.renderContent();
    };
    BusyIndicator.prototype.renderContent = function () {
        return this.props.children;
    };
    BusyIndicator.prototype.renderBusyIndicator = function () {
        var style = {
            display: 'flex',
            justifyContent: 'center',
            padding: '1em'
        };
        return (React.createElement("div", { style: style },
            React.createElement(CircularProgress, { size: this.props.size || 30, style: { zIndex: 9999 } })));
    };
    return BusyIndicator;
}(React.Component));
export default BusyIndicator;



//////////////////
// WEBPACK FOOTER
// ./src/components/BusyIndicator.tsx
// module id = 114
// module chunks = 0